__turbopack_context__.v({
  "image": "styles-module-scss-module__yUcuqG__image",
});
